import { render, staticRenderFns } from "./IntroduceSection.vue?vue&type=template&id=d74ca13c&scoped=true&"
import script from "./IntroduceSection.vue?vue&type=script&lang=js&"
export * from "./IntroduceSection.vue?vue&type=script&lang=js&"
import style0 from "./IntroduceSection.vue?vue&type=style&index=0&id=d74ca13c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74ca13c",
  null
  
)

export default component.exports